<template>
  <b-card class="module-card" no-body @click="handleClick">
    <div class="image-container" :class="{ hovered: isHovered }">
      <b-card-img
        :src="imageSrc"
        alt="Module Image"
        class="module-image"
        fluid
      ></b-card-img>
      <div class="module-title-container">
        <h5 class="module-title"></h5>
      </div>
      <div class="overlay">
        <div class="text-content">
          <p ></p>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "ModuleCard",
  props: {
    moduleNumber: {
      type: Number,
      required: true,
    },
    moduleTitle: {
      type: String,
      required: true,
    },
    imageSrc: {
      type: String,
      required: true,
    },
    isHovered: { // El estado de hovered ahora viene del componente padre
      type: Boolean,
      required: true,
    },
  },
  methods: {
    handleClick() {
      // Emitir el evento para informar al padre que este módulo fue seleccionado
      this.$emit("hoveredModule", this.moduleNumber);
    },
  },
};
</script>

<style scoped>
.module-card {
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  height: 400px;
  border-radius: 15px;
  border: 2px solid #76b8f1;
  cursor: pointer;
}

.image-container {
  position: relative;
  height: 100%;
  transition: transform 0.3s ease;
}

.module-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 15px;
}

.module-image {
  width: 100%;
  height: auto;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
}

.text-content {
  color: white;
  text-align: center;
}

.module-title {
  font-size: 22px;
  font-weight: bold;
}

.module-title-container {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px 0;
  color: white;
  z-index: 2;
}

.module-description {
  font-size: 16px;
  padding: 7px 16px;
  background-color: #fff;
  color: #061834;
  border-radius: 15px;
  font-weight: 600;
}

/* Efecto hover */
.image-container.hovered {
  transform: scale(1.05); 
}

.overlay.hovered {
  background: none;
}

.image-container.hovered .overlay {
  background: none;
}

</style>
